import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-2xl lg:max-w-7xl mx-auto space-y-10" }
const _hoisted_2 = { class: "max-w-2xl flex flex-col gap-6" }
const _hoisted_3 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-16" }
const _hoisted_4 = { class: "lg:col-span-5 lg:order-2" }
const _hoisted_5 = { class: "flex items-center gap-4" }
const _hoisted_6 = {
  key: 0,
  class: "max-w-xl flex flex-col gap-8 lg:col-span-7 lg:order-1"
}

import type { WithTestimonialProps } from "./WithTestimonialProps";
import type { PageBlock } from "@/views/blocks/PageBlock.interface";
import type { CssVarColors } from "@/shared/themes/CssVarColors.interface";
import { computed } from "vue";
import type { ScrollAnimationType } from "@/apps/page/page-project.interface";
import Section from "@/views/blocks/shared/section/layout/section/Section.vue";
import FullSpacing from "@/views/blocks/shared/section/layout/spacing/FullSpacing.vue";
import Heading from "@/views/blocks/shared/section/typography/heading/Heading.vue";
import Paragraph from "@/views/blocks/shared/section/typography/paragraph/Paragraph.vue";
import Image from "@/views/blocks/shared/section/media/image/Image.vue";
import EditableElement from "@/views/page/EditableElement.vue";
import Features from "@/views/blocks/shared/section/features/Features.vue";
import Feature from "@/views/blocks/shared/section/features/Feature.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'WithTestimonial',
  props: {
    block: {},
    pageColors: {},
    scrollAnimationType: {}
  },
  setup(__props: any) {



const dataValues = computed(() => __props.block.dataValues);
const styleValues = computed(() => __props.block.styleValues);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Section, {
    id: _ctx.block.webId,
    backgroundColor: styleValues.value.background,
    scrollAnimationType: _ctx.scrollAnimationType
  }, {
    default: _withCtx(() => [
      _createVNode(FullSpacing, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (!dataValues.value.tag.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 0,
                    blockId: _ctx.block.id,
                    fieldName: "tag"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Heading, {
                        text: dataValues.value.tag.data.text,
                        tag: dataValues.value.tag.data.tag,
                        textColor: styleValues.value.brand,
                        class: "text-base/7"
                      }, null, 8, ["text", "tag", "textColor"])
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true),
              (!dataValues.value.title.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 1,
                    blockId: _ctx.block.id,
                    fieldName: "title"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Heading, {
                        text: dataValues.value.title.data.text,
                        tag: dataValues.value.title.data.tag,
                        textColor: styleValues.value.text,
                        class: "text-4xl lg:text-5xl"
                      }, null, 8, ["text", "tag", "textColor"])
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true),
              (!dataValues.value.description.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 2,
                    blockId: _ctx.block.id,
                    fieldName: "description"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Paragraph, {
                        text: dataValues.value.description.data.text,
                        textColor: styleValues.value.text,
                        class: "text-xl/8 opacity-70"
                      }, null, 8, ["text", "textColor"])
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (!dataValues.value.testimonial.isHidden)
                  ? (_openBlock(), _createBlock(EditableElement, {
                      key: 0,
                      blockId: _ctx.block.id,
                      fieldName: "testimonial"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "pl-8 border-l space-y-8",
                          style: _normalizeStyle({
                                    borderColor: styleValues.value.brand,
                                })
                        }, [
                          _createVNode(Paragraph, {
                            text: dataValues.value.testimonial.data.text,
                            textColor: styleValues.value.text,
                            class: "text-xl/8 italic"
                          }, null, 8, ["text", "textColor"]),
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(Image, {
                              src: dataValues.value.testimonial.data.personImageSrc,
                              alt: dataValues.value.testimonial.data.personName,
                              class: "w-10 h-10 rounded-full",
                              width: "40",
                              height: "40"
                            }, null, 8, ["src", "alt"]),
                            _createElementVNode("div", null, [
                              _createVNode(Paragraph, {
                                text: dataValues.value.testimonial.data.personName,
                                textColor: styleValues.value.text,
                                class: "text-sm/6 font-semibold"
                              }, null, 8, ["text", "textColor"]),
                              _createVNode(Paragraph, {
                                text: dataValues.value.testimonial.data.personPosition,
                                textColor: styleValues.value.text,
                                class: "text-sm/6 opacity-70"
                              }, null, 8, ["text", "textColor"])
                            ])
                          ])
                        ], 4)
                      ]),
                      _: 1
                    }, 8, ["blockId"]))
                  : _createCommentVNode("", true)
              ]),
              (
                            !dataValues.value.topText.isHidden ||
                            dataValues.value.features.data.items.length > 0 ||
                            !dataValues.value.bottomText.isHidden ||
                            !dataValues.value.secondaryTitle.isHidden ||
                            !dataValues.value.secondaryDescription.isHidden
                        )
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (!dataValues.value.topText.isHidden)
                      ? (_openBlock(), _createBlock(EditableElement, {
                          key: 0,
                          blockId: _ctx.block.id,
                          fieldName: "topText"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(Paragraph, {
                              text: dataValues.value.topText.data.text,
                              textColor: styleValues.value.text,
                              class: "text-base/7 opacity-70"
                            }, null, 8, ["text", "textColor"])
                          ]),
                          _: 1
                        }, 8, ["blockId"]))
                      : _createCommentVNode("", true),
                    (dataValues.value.features.data.items.length > 0)
                      ? (_openBlock(), _createBlock(Features, { key: 1 }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataValues.value.features.data.items, (feature) => {
                              return (_openBlock(), _createBlock(Feature, {
                                key: feature.id,
                                title: feature.title,
                                description: feature.description,
                                "icon-src": feature.iconSrc,
                                "title-text-color": styleValues.value.text,
                                "description-text-color": styleValues.value.text,
                                "description-opacity": 70
                              }, null, 8, ["title", "description", "icon-src", "title-text-color", "description-text-color"]))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (!dataValues.value.bottomText.isHidden)
                      ? (_openBlock(), _createBlock(EditableElement, {
                          key: 2,
                          blockId: _ctx.block.id,
                          fieldName: "bottomText"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(Paragraph, {
                              text: dataValues.value.bottomText.data.text,
                              textColor: styleValues.value.text,
                              class: "text-base/7 opacity-70"
                            }, null, 8, ["text", "textColor"])
                          ]),
                          _: 1
                        }, 8, ["blockId"]))
                      : _createCommentVNode("", true),
                    (!dataValues.value.secondaryTitle.isHidden)
                      ? (_openBlock(), _createBlock(EditableElement, {
                          key: 3,
                          blockId: _ctx.block.id,
                          fieldName: "secondaryTitle"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(Heading, {
                              text: dataValues.value.secondaryTitle.data.text,
                              tag: dataValues.value.secondaryTitle.data.tag,
                              textColor: styleValues.value.text,
                              class: "text-2xl font-bold"
                            }, null, 8, ["text", "tag", "textColor"])
                          ]),
                          _: 1
                        }, 8, ["blockId"]))
                      : _createCommentVNode("", true),
                    (!dataValues.value.secondaryDescription.isHidden)
                      ? (_openBlock(), _createBlock(EditableElement, {
                          key: 4,
                          blockId: _ctx.block.id,
                          fieldName: "secondaryDescription"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(Paragraph, {
                              text: dataValues.value.secondaryDescription.data.text,
                              textColor: styleValues.value.text,
                              class: "text-base/7 opacity-70"
                            }, null, 8, ["text", "textColor"])
                          ]),
                          _: 1
                        }, 8, ["blockId"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["id", "backgroundColor", "scrollAnimationType"]))
}
}

})